import { PageBreak, Paragraph, TextRun } from 'docx'
import moment from 'moment'

const Chapter1Page = ({ reportData }) => {
  const {
    trainingPeopleTotal,
    trainingCompletionRate,
    completionRate,
    attendPeople,
    attendRate,
    firstPartyAbbreviation,
    secondPartyAbbreviation,
    secondPartyFullName,
    courseName,
    courseStartDate,
    courseEndDate,
  } = reportData || {}

  return [
    new Paragraph({ children: [new PageBreak()] }),
    new Paragraph({
      children: [
        new TextRun('第一章 本文件資訊之揭露與限制'),
        new TextRun({ text: '此文件包含', break: 1 }),
        new TextRun({ text: firstPartyAbbreviation }),
        new TextRun('執行教育安全訓練服務所取得的相關資訊。'),
        new TextRun({ text: secondPartyAbbreviation }),
        new TextRun(
          '建議採取特別保密措施以保護此份文件和其內容，且此問見的所有副本均將交付予客戶。資訊安全評估是根據過去的經驗、目前可取得的資訊和已知的威脅，而這些因素可造成評估過程的不確定性。',
        ),
        new TextRun({ text: '由於資訊安全是一個不斷發展和變化的領域，經', break: 1 }),
        new TextRun({ text: secondPartyAbbreviation }),
        new TextRun(
          '提供資訊安全教育訓練後，並不意味不會發生社交工程攻擊資安事件，企業應不斷加強資安教育訓練，強化人員資安意識。',
        ),
        new TextRun({ text: '此文件是由', break: 1 }),
        new TextRun({ text: secondPartyAbbreviation }),
        new TextRun('製作，其內容為版權所有，並僅提供'),
        new TextRun({ text: firstPartyAbbreviation }),
        new TextRun('使用，此份文件對任何第三方的揭露須遵守'),
        new TextRun({ text: firstPartyAbbreviation }),
        new TextRun('和'),
        new TextRun({ text: secondPartyFullName }),
        new TextRun('之間的合約及保密協定。'),
      ],
    }),
    new Paragraph(''),
    new Paragraph({
      children: [
        new TextRun('第二章 執行摘要'),
        new TextRun({ text: '本文件提出對', break: 1 }),
        new TextRun({ text: firstPartyAbbreviation }),
        new TextRun(
          '的未通過社交工程演練測試的受測對象進行資訊安全教育訓練的結果，此文件統計目的是了解該企業落實強化資安意識的辦理情形及數據統計。',
        ),
        new TextRun({ text: '此次資安教育訓練時程為', break: 1 }),
        new TextRun({ text: moment(courseStartDate).format('YYYY年MM月DD日') }),
        new TextRun('至'),
        new TextRun({ text: moment(courseEndDate).format('YYYY年MM月DD日') }),
        new TextRun({
          text: '第三章的受訓成果報告說明{甲方公司簡稱}受訓人員參與情形以及課程完成率。',
          break: 1,
        }),
      ],
    }),
    new Paragraph(''),
    new Paragraph({
      children: [
        new TextRun('第三章 受訓成果報告'),
        new TextRun({ text: '1. 訓練名稱 : ', break: 1 }),
        new TextRun({ text: courseName }),
        new TextRun({
          text: '2. 訓練目標和目的 : 資安教育訓練的目標在於強化受測人員的資安意識，目的在於保護受測人員所在的企業免遭受到資安攻擊造成企業損失。',
          break: 1,
        }),
        new TextRun({ text: '3. 訓練日期和時間 : ', break: 1 }),
        new TextRun({ text: moment(courseStartDate).format('YYYY年MM月DD日') }),
        new TextRun('至'),
        new TextRun({ text: moment(courseEndDate).format('YYYY年MM月DD日') }),
        new TextRun({ text: '4. 訓練人數 : 測試結束後不合格的人數 -', break: 1 }),
        new TextRun({ text: `${trainingPeopleTotal}` }),
        new TextRun('人'),
        new TextRun({ text: '5. 訓練名單 : 請參考附件一', break: 1 }),
        new TextRun({ text: '6. 出席人數 : 觀看影片長度超過20%的人數 -', break: 1 }),
        new TextRun({ text: `${attendPeople}` }),
        new TextRun('人'),
        new TextRun({ text: '7. 出席率 : 觀看影片長度超過20%人數/總人數 -', break: 1 }),
        new TextRun({ text: `${attendRate}` }),
        new TextRun('%'),
        new TextRun({ text: '8. 訓練完成率 : 完成觀看影片人數/總人數 -', break: 1 }),
        new TextRun({ text: `${trainingCompletionRate}` }),
        new TextRun('%'),
        new TextRun({ text: '9. 未完成訓練名單 : 請參考附件二', break: 1 }),
        new TextRun({
          text: '10. 單位完成率統計 : 該單位受訓出席人數/該單位受訓總人數 -',
          break: 1,
        }),
        new TextRun({ text: `${completionRate}` }),
        new TextRun('%'),
      ],
    }),
  ]
}

export default Chapter1Page
